import { Modal } from 'antd';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { CrossInCircleIcon } from '@components/common/Icons/CrossInCircleIcon';
import { CalculatorDialogProps } from './types';
import { colors } from '@/variables';
import { links } from './helpers';

export const CalculatorDialog: FC<CalculatorDialogProps> = ({ onClose, open = true }) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      footer={null}
      closable={false}
      centered
      width={'fit-content'}
      classNames={{
        content: 'relative rounded-[1.4rem]! p-[3.3rem_2.5rem]!',
        body: 'p-0!',
      }}
      styles={{
        content: { borderRadius: '1.4rem' },
      }}
    >
      <CrossInCircleIcon
        className={'absolute top-5 right-5 cursor-pointer'}
        color={colors.primary}
        onClick={handleClose}
      />
      <ul className={'m-0 p-0'}>
        {links.map(({ labelKey, url, icon, isSeparated }) => (
          <div key={labelKey}>
            <li className={'list-none px-3 py-2'}>
              <a
                href={url}
                className={'font-satoshi-medium text-ash flex items-center text-lg font-medium no-underline'}
              >
                {icon}
                <span className={'ml-2'}>
                  <FormattedMessage id={labelKey} />
                </span>
              </a>
            </li>
            {isSeparated && (
              <div className='border-purply my-3 h-px w-full border-x-0 border-t-0 border-b border-solid' />
            )}
          </div>
        ))}
      </ul>
    </Modal>
  );
};
